
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_447_1017)"}},[_c('path',{attrs:{"d":"M.838 8.288l1.325.552a1.456 1.456 0 001.115.002l.906-.373a.814.814 0 01.629.002l.864.364c.363.153.763.154 1.127.002l.882-.367a.811.811 0 01.629 0l.882.367c.363.152.763.151 1.127-.002l.864-.364a.813.813 0 01.629-.002l.906.373c.36.148.756.148 1.116-.003l1.325-.551a.32.32 0 00.197-.295v-1.92a.96.96 0 00-.96-.96h-2.88v-.7a.958.958 0 00.64-.9c0-.752-.659-1.432-.734-1.507a.32.32 0 00-.453 0c-.075.075-.733.755-.733 1.507 0 .416.268.768.64.9v.7H8.32v-1.34a.958.958 0 00.64-.9c0-.696-.605-1.926-.674-2.064-.11-.217-.464-.217-.572 0-.07.138-.674 1.368-.674 2.064 0 .416.268.768.64.9v1.34H5.12v-.7a.958.958 0 00.64-.9c0-.752-.659-1.432-.734-1.507a.32.32 0 00-.453 0c-.075.075-.733.755-.733 1.507 0 .416.268.768.64.9v.7H1.6a.96.96 0 00-.96.96v1.92a.32.32 0 00.197.295zM15.04 12.793H.96a.96.96 0 00-.96.96c0 .882.717 1.6 1.6 1.6h12.8c.883 0 1.6-.718 1.6-1.6a.96.96 0 00-.96-.96zM12.479 9.433l-.907-.373a.177.177 0 00-.137.001l-.863.364a2.083 2.083 0 01-1.622.003l-.882-.367a.175.175 0 00-.136 0l-.883.367a2.086 2.086 0 01-1.622-.003l-.863-.364a.186.186 0 00-.07-.014.184.184 0 00-.068.014l-.905.372a2.086 2.086 0 01-1.604-.002l-.637-.265v2.987h13.44V9.166l-.636.265a2.083 2.083 0 01-1.605.002z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_447_1017"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    